export function showToast(message: string, type: 'success' | 'error' = 'success') {
    const toastNotification = document.getElementById('toastNotification');
    const toastMessage = document.getElementById('toastMessage');
    if (!toastNotification || !toastMessage) return;
    toastMessage.textContent = message;
    toastNotification.classList.remove('bg-green-500', 'bg-red-500', 'opacity-0', 'translate-y-2');
    toastNotification.classList.add(type === 'success' ? 'bg-green-500' : 'bg-red-500');
    toastNotification.classList.remove('hidden');
    
    void toastNotification.offsetWidth;
    toastNotification.classList.add('opacity-100', 'translate-y-0');
    
    setTimeout(() => {
        toastNotification.classList.remove('opacity-100', 'translate-y-0');
        toastNotification.classList.add('opacity-0', 'translate-y-2');
        setTimeout(() => {
            toastNotification.classList.add('hidden');
        }, 300);
    }, 3000);
}

export function createApplicationCard(app: any, index: number) {
    const card = document.createElement('div');
    card.className = `application-card glassmorphic p-5 rounded-lg shadow-lg flex flex-col justify-between space-y-3 animate-fadeInSlideUp`;
    card.style.animationDelay = `${index * 0.06}s`;
    card.dataset.id = app.id;
    card.dataset.company = app.companyName;
    
    const displayDate = app.dateApplied 
        ? new Date(app.dateApplied).toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          }) 
        : 'N/A';

    let daysSinceAppliedText = '';
    if (app.dateApplied) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const appliedDate = new Date(app.dateApplied);
        const diffTime = Math.abs(today.getTime() - appliedDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (appliedDate > today) daysSinceAppliedText = `(Future Entry)`;
        else if (diffDays === 0) daysSinceAppliedText = `(Today)`;
        else if (diffDays === 1) daysSinceAppliedText = `(1 day ago)`;
        else daysSinceAppliedText = `(${diffDays} days ago)`;
    }

    let lastUpdatedText = '';
    if (app.lastUpdatedAt && app.lastUpdatedAt.toDate) {
        const updatedDate = app.lastUpdatedAt.toDate();
        lastUpdatedText = `Updated: ${updatedDate.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric'
        })}, ${updatedDate.toLocaleTimeString('en-US', { 
            hour: 'numeric', 
            minute: '2-digit', 
            hour12: true 
        })}`;
    }

    card.innerHTML = `
        <div class="card-content">
            <h3 class="text-xl font-semibold text-sky-300 truncate mb-1" title="${app.companyName} - ${app.jobTitle}">${app.companyName}</h3>
            <p class="text-slate-300 text-sm mb-3">${app.jobTitle}</p>
            <div class="text-sm text-slate-400 space-y-1.5">
                <p><i class="ph-calendar-blank inline-block mr-1.5 text-sky-400 align-middle"></i>Applied: ${displayDate} <span class="text-xs text-slate-500">${daysSinceAppliedText}</span></p>
                <p><i class="ph-activity inline-block mr-1.5 text-sky-400 align-middle"></i>Status: <span class="status-badge status-${app.status.replace(/\s+/g, '')}">${app.status}</span></p>
                ${app.jobUrl ? `<p class="truncate"><i class="ph-link inline-block mr-1.5 text-sky-400 align-middle"></i><a href="${app.jobUrl}" target="_blank" rel="noopener noreferrer" class="hover:text-sky-300 underline decoration-dotted decoration-sky-500/50 underline-offset-2" title="${app.jobUrl}">Job Link</a></p>` : ''}
                ${lastUpdatedText ? `<p class="text-xs text-slate-500 mt-1.5"><i class="ph-clock inline-block mr-1 text-slate-500 align-middle"></i>${lastUpdatedText}</p>` : ''}
            </div>
            ${app.notes ? `<p class="text-xs text-slate-300 bg-slate-800/50 p-2.5 rounded-md mt-3 max-h-24 overflow-y-auto notes-preview"><strong>Notes:</strong> ${app.notes.length > 120 ? app.notes.substring(0, 120) + '...' : app.notes}</p>` : ''}
        </div>
        <div class="card-actions">
            <button class="calendar-btn btn btn-secondary icon-btn" data-id="${app.id}" title="Add Follow-up to Google Calendar">
                <i class="ph-calendar-plus"></i>
            </button>
            <button class="edit-btn btn btn-secondary icon-btn" data-id="${app.id}" data-company="${app.companyName}" title="Edit Application">
                <i class="ph-pencil-simple"></i>
            </button>
            <button class="delete-btn btn btn-danger icon-btn" data-id="${app.id}" data-company="${app.companyName}" title="Delete Application">
                <i class="ph-trash"></i>
            </button>
        </div>
    `;
    
    return card;
}

export function updateStats(stats: { total: number; interviewing: number; offers: number; awaitingResponse: number; }) {
    const statTotal = document.getElementById('statTotalApplications');
    const statInterviewing = document.getElementById('statInterviewing');
    const statOffers = document.getElementById('statOffers');
    const statAwaiting = document.getElementById('statAwaitingResponse');
    if (statTotal) statTotal.textContent = stats.total.toString();
    if (statInterviewing) statInterviewing.textContent = stats.interviewing.toString();
    if (statOffers) statOffers.textContent = stats.offers.toString();
    if (statAwaiting) statAwaiting.textContent = stats.awaitingResponse.toString();
}